import Section from '@app/components/atoms/Section/Section'
import { getEndOfPreviusMonth, getStartOfPreviusMonth } from '@app/libs/format'
import { Link } from '@inertiajs/inertia-react'
import HistoryIcon from '@mui/icons-material/History'
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'

export default function ReportIndex() {
  const { t } = useTranslation()

  const start_at = getStartOfPreviusMonth()
  const end_at = getEndOfPreviusMonth()

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Section>
          <Grid container alignItems="center" spacing={2}>
            <Grid item xs={4}>
              <Grid container alignContent="center">
                <MonetizationOnIcon sx={{ mr: 2 }} />
                <span>
                  <Link
                    href={route('admin.report.cost', {
                      trans_start_at: start_at,
                      trans_end_at: end_at,
                    })}
                    style={{ textDecoration: 'none' }}
                  >
                    <Typography>{t('REPORT.COST_REPORT')}</Typography>
                  </Link>
                </span>
              </Grid>
            </Grid>
            <Grid item xs={4}>
              <Grid container alignContent="center">
                <HistoryIcon sx={{ mr: 2 }} />
                <span>
                  <Link
                    href={route('admin.report.transaction', {
                      updated_at_start_at: start_at,
                      updated_at_end_at: end_at,
                    })}
                    style={{ textDecoration: 'none' }}
                  >
                    <Typography>{t('REPORT.TRANSACTION_REPORT')}</Typography>
                  </Link>
                </span>
              </Grid>
            </Grid>
          </Grid>
        </Section>
      </Grid>
    </Grid>
  )
}
